import { makeAutoObservable } from 'mobx'
import type { IChatbotSettings } from '../type'

export class ChatbotKnowledgeBase {
  useKnowledgeBase = false

  constructor() {
    makeAutoObservable(this)
  }

  setUseKnowledgeBase = (value: boolean) => {
    this.useKnowledgeBase = value
  }

  syncOrigin(settings?: IChatbotSettings | null) {
    this.useKnowledgeBase = settings?.use_knowledge_base?.value ?? false
  }

  toSettingsJSON(): Pick<IChatbotSettings, 'use_knowledge_base'> {
    return {
      use_knowledge_base: { value: this.useKnowledgeBase },
    }
  }
}
